import { Pipe, PipeTransform } from '@angular/core';
import { NoteType } from '@shared/enums/NoteType';

@Pipe({
    name: 'icon'
})
export class IconPipe implements PipeTransform {
    transform(value: number, type: string): string {
        let icon = 'exclamation-circle';
        if (type && value) {
            switch (type) {
                case 'notes':
                    switch (value) {
                        case NoteType.Note:
                            icon = 'file-text-o';
                            break;
                        case NoteType.Task:
                            icon = 'clock-o';
                            break;
                    }
                    break;
            }
        }
        return icon;
    }
}
